<script>
export default {
  props: {
    icon: String,
    text: String,
    to: {
      type: String,
    },
  },
};
</script>

<template>
  <RouterLink
    v-if="$props.to"
    :to="$props.to"
    class="dropdown-item py-2 px-4 flex items-center"
  >
    <i :class="icon" class="mr-2 default-icon" />
    <h6>{{ text }}</h6>
  </RouterLink>
  <a v-else href="#" class="dropdown-item py-2 px-4 flex items-center">
    <i :class="icon" class="mr-2 default-icon" />
    <h6>{{ text }}</h6>
  </a>
</template>

<style scoped>
.dropdown-item {
  transition: all 0.2s ease;
}

.dropdown-item:hover {
  background: var(--brand-gradient-hover);
}
</style>
